import React, { useContext, useEffect, useState } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Grid,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import EventBusyIcon from '@mui/icons-material/EventBusy';

import { stringToLocaleDateString } from '../../../../helpers';
import { UtenteLink } from '../../../common';
import { NavContext, NavRoutes } from "../../../contexts";
import { RegioniContext } from '../RegioniContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const RegioniList = ({
    searchText,
    itemsPerPage,
    disabled,
    onLoadMore,
    onActionClick,
    ...props
}) => {

    const {
        getRouteTo
    } = useContext(NavContext);

    const {
        state,
    } = useContext(RegioniContext);

    const {
        regioni
    } = state;

    const [pageIndex, setPageIndex] = useState(0);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    }

    const deleteClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Delete", data);
    }

    const addClickHandler = (data) => {
        if (onActionClick)
            onActionClick("Add", data);
    }

    const [validFilter, setValidFilter] = useState(true);

    useEffect(() => {
        if (regioni && onLoadMore) {
            onLoadMore(0, pageSize, searchText, validFilter);
        }
    }, [searchText]);

    const [pageSize, setPageSize] = useState(itemsPerPage);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value)
    }

    useEffect(() => {
        if (regioni && onLoadMore) {
            onLoadMore(pageIndex, pageSize, searchText, validFilter);
        }
    }, [pageIndex, pageSize, validFilter]);

    return (
        <div>
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                sx={{ marginTop: 3 }}>
                {regioni ? regioni.totalCount : 0}&nbsp;Record trovati
            </Typography>
            <Card>
                <CardHeader
                    titleTypographyProps={{ variant: "h6" }}
                    title={
                        <Grid container justifyContent="space-between">
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Typography variant="h6">
                                    Tutte le Regioni
                                </Typography>
                                <div style={{ display: "flex", alignItems: "center", color: "white !important" }}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Checkbox
                                                onChange={e => {
                                                    setValidFilter(!validFilter);
                                                }}
                                                checked={validFilter}
                                                sx={{ color: "white" }}
                                            />
                                            <Typography variant='caption'>
                                                ATTIVI
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>

                            <Grid item>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    disabled={disabled}
                                    onClick={addClickHandler}>
                                    Aggiungi
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    sx={{ backgroundColor: "secondary.main", color: "white" }}
                />
                <Divider />
                <CardContent sx={{ padding: 0 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "aliceblue", }}>
                            <TableRow>
                                <TableCell style={{ width: "40%" }}>Nome</TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>Inizio validità</TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>Fine validità</TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Inserito da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Modificato da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data inserimento
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data Modifica
                                </TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {regioni && regioni.result.length > 0
                                && regioni.result.map((regione, index) => {
                                    return (
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                <div sx={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <div>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.Regione, [regione.id]), "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}>
                                                            {regione.descrizione}
                                                            {
                                                                (
                                                                    regione.fineValidita && regione.fineValidita <= new Date()
                                                                ) &&
                                                                <EventBusyIcon color="error" />
                                                            }
                                                        </Link>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div sx={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <Typography align="center" fontSize={14}>
                                                        {regione.inizioValidita.toLocaleDateString("it-IT")}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div sx={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <Typography align="center" fontSize={14}>
                                                        {regione.fineValidita ? regione.fineValidita.toLocaleDateString("it-IT") : '-'}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={regione?.creatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={regione?.aggiornatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(regione.dataCreazione)}
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(regione.dataAggiornamento)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    aria-label="delete"
                                                    disabled={disabled}
                                                    onClick={() => deleteClickHandler(regione)}>
                                                    <Tooltip title="elimina regione">
                                                        <DeleteIcon />
                                                    </Tooltip>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            }
                        </TableBody>
                    </Table>
                </CardContent>
                <TablePagination
                    component="div"
                    count={regioni ? regioni.totalCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
        </div>
    );
}